import { useCallback } from 'react'

import { useCreateTlsiConnectorMutation } from '@/core/services/dmp-connect-js2'

import { useAppSelector } from '@/redux/rootReducer'
import { selectCpxCard } from '@/redux/reducers/dmp-connect.reducer'

import { decodePinCode } from '@/utils/dmp-connect.util'

export function useCreateInsiConnector() {
  const cpxCard = useAppSelector(selectCpxCard)
  const [createInsiConnectorMutation, { isLoading: isCreatingInsiConnector }] = useCreateTlsiConnectorMutation()

  const createInsiConnector = useCallback(
    async (billingNumber: string, practiceLocation: number, practiceSetting: string) => {
      if (!cpxCard) return

      try {
        const pinCode = decodePinCode(cpxCard.encodedPinCode)
        await createInsiConnectorMutation({
          billingNumber,
          i_cpsPracticeLocationIndice: practiceLocation,
          s_pinCode: pinCode,
          s_practiceSetting: practiceSetting,
        }).unwrap()
      } catch (error) {
        // Error handling can be added here if needed
      }
    },
    [cpxCard, createInsiConnectorMutation]
  )

  return {
    createInsiConnector,
    isCreatingInsiConnector,
  }
}
